import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {HomeHorasExtrasComponent} from './views/home-horas-extras/home-horas-extras.component';
import {HorasExtrasRoutingModule} from "./horas-extras-routing.module";
import {ParametrizacionFeriadosComponent} from './views/parametrizacion-feriados/parametrizacion-feriados.component';
import {SharedModule} from "../../shared/shared.module";
import {AgGridModule} from "ag-grid-angular";

import {LfsaBotonsGridComponent} from '../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import {LfsaBotonEditarGridComponent} from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  ParametrizacionPorcentajeRecargaComponent
} from './views/parametrizacion-porcentaje-recarga/parametrizacion-porcentaje-recarga.component';
import {ParametrizacionEmpleadosComponent} from './views/parametrizacion-empleados/parametrizacion-empleados.component';
import {
  ParametrizacionFechaCorteComponent
} from './views/parametrizacion-fecha-corte/parametrizacion-fecha-corte.component';
import {HorasExtraCargaTurnosComponent} from './views/horas-extra-carga-turnos/horas-extra-carga-turnos.component';
import {ModificacionMarcacionesComponent} from './views/modificacion-marcaciones/modificacion-marcaciones.component';
import {
  VerificacionTalentoHumanoComponent
} from './views/verificacion-talento-humano/verificacion-talento-humano.component';
import {
  ModificacionMarcacionesRecursosHumanosComponent
} from './views/modificacion-marcaciones-recursos-humanos/modificacion-marcaciones-recursos-humanos.component';
import {CheckboxRenderer} from "../../shared/components/lfsa-checkbox/lfsa-checkbox.component";
import {
  VerificacionTalentoHumanoRecursosHumanosComponent
} from './views/verificacion-talento-humano-recursos-humanos/verificacion-talento-humano-recursos-humanos.component';
import {
  VerificacionTalentoHumanoRecursosHumanosCalculadoComponent
} from './views/verificacion-talento-humano-recursos-humanos-calculado/verificacion-talento-humano-recursos-humanos-calculado.component';
import {ModalEmpleadoComponent} from './views/modal-empleado/modal-empleado.component';
import {
  ParametrizacionMinutosGraciaComponent
} from './views/parametrizacion-minutos-gracia/parametrizacion-minutos-gracia.component';
import {
  ParametrizacionLocalidadesTurnosComponent
} from './views/parametrizacion-localidades-turnos/parametrizacion-localidades-turnos.component';
import {
  ParametrizacionReemplazoEmpleadosComponent
} from './views/parametrizacion-reemplazo-empleados/parametrizacion-reemplazo-empleados.component';
import {
  VerificacionTalentoHumanoSegundaValidacionComponent
} from './views/verificacion-talento-humano-segunda-validacion/verificacion-talento-humano-segunda-validacion.component';
import {
  ParametrizacionTipoTurnoComponent
} from './views/parametrizacion-tipo-turno/parametrizacion-tipo-turno.component';
import {
  ReplicaMarcacionEmpleadoComponent
} from './views/replica-marcacion-empleado/replica-marcacion-empleado.component';
import {
  ReplicaMarcacionDepartamentoComponent
} from './views/replica-marcacion-departamento/replica-marcacion-departamento.component';


@NgModule({
  declarations: [
    HomeHorasExtrasComponent,
    ParametrizacionFeriadosComponent,
    ParametrizacionPorcentajeRecargaComponent,
    ParametrizacionEmpleadosComponent,
    ParametrizacionFechaCorteComponent,
    HorasExtraCargaTurnosComponent,
    ModificacionMarcacionesComponent,
    VerificacionTalentoHumanoComponent,
    ModificacionMarcacionesRecursosHumanosComponent,
    VerificacionTalentoHumanoRecursosHumanosComponent,
    VerificacionTalentoHumanoRecursosHumanosCalculadoComponent,
    ModalEmpleadoComponent,
    ParametrizacionMinutosGraciaComponent,
    ParametrizacionLocalidadesTurnosComponent,
    ParametrizacionReemplazoEmpleadosComponent,
    VerificacionTalentoHumanoSegundaValidacionComponent,
    ParametrizacionTipoTurnoComponent,
    ReplicaMarcacionEmpleadoComponent,
    ReplicaMarcacionDepartamentoComponent,
  ],
  imports: [
    CommonModule,
    HorasExtrasRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent, LfsaBotonsGridComponent, CheckboxRenderer]),
    FormsModule,
  ],
  providers: [
    DecimalPipe
  ]
})
export class HorasExtrasModule {
}
